import React from 'react';
import {
  NO_CONSENTS_GIVEN,
  useOutstandingConsents,
} from 'LoggedOut/PrivacyConsent/useOutstandingConsents';
import PrivacyConsentForm, {
  PrivacyConsentFormProps,
} from './PrivacyConsentForm';

type SignUpPrivacyConsentFormProps = Omit<
  PrivacyConsentFormProps,
  'outstandingConsents' | 'loadingConsents'
>;

/** Supplies the outstanding set, which the wizard cannot pass through. */
const SignUpPrivacyConsentForm = (props: SignUpPrivacyConsentFormProps) => {
  const { outstandingConsents, loading } =
    useOutstandingConsents(NO_CONSENTS_GIVEN);

  return (
    <PrivacyConsentForm
      {...props}
      outstandingConsents={outstandingConsents}
      loadingConsents={loading}
    />
  );
};

export default SignUpPrivacyConsentForm;
